document.querySelectorAll(".video-launch").forEach((videoLaunch) => {
  videoLaunch.addEventListener("click", handleVideoModal);
  videoLaunch.addEventListener("keypress", (e) => {
    if (e.which === 13) {
      handleVideoModal(e);
    }
  });
});

function handleVideoModal(e) {
  const modalID = e.currentTarget.getAttribute("href");
  if (!modalID) {
    return;
  }

  const modal = document.querySelector(modalID);
  if (!modal) {
    return;
  }

  document.documentElement.classList.add("no-scroll");
  document.body.classList.add("video-modal-open");
  const iframe = modal.querySelector("iframe");
  const closeModal = modal.querySelector(".close-video-modal");
  const src = iframe.getAttribute("src");

  modal.classList.add("show-video-modal");
  iframe.setAttribute("src", src + "?autoplay=1");
  closeModal.focus();
}

document.querySelectorAll(".close-video-modal").forEach((i) => {
  i.addEventListener("click", (e) => {
    document.documentElement.classList.remove("no-scroll");
    document.body.classList.remove("video-modal-open");
    var modal = i.parentElement;
    var iframe = modal.querySelector("iframe");
    var src = iframe.getAttribute("src");
    var srcOriginal = src.substring(0, src.length - 11);
    modal.classList.remove("show-video-modal");
    iframe.setAttribute("src", srcOriginal);
  });
});
